import L from 'leaflet'

export interface Snapshot {
  id?: number
  name: string
  description: string
  date: Date
  scale: string
  zones: Array<string | any> // nuts or areas
  layers: string[]
  uploadedLayers: number[]
  center: L.LatLng
  zoom: number
  sharedWith?: string[]
  ownerEmail?: string
}

export function parseToFront(snapshotBackend: any): Snapshot {
  const date = new Date(snapshotBackend['date'])

  const centerJson = snapshotBackend['center']
  const center = new L.LatLng(centerJson['lat'], centerJson['lng'])

  const snap: Snapshot = {
    id: snapshotBackend['id'],
    name: snapshotBackend['name'],
    description: snapshotBackend['description'],
    date: date,
    sharedWith: snapshotBackend['shared_with'],
    scale: snapshotBackend['scale'],
    zones: snapshotBackend['zones'],
    layers: snapshotBackend['layers'],
    uploadedLayers: snapshotBackend['uploaded_layers'],
    center: center,
    zoom: snapshotBackend['zoom'],
  }

  if (snapshotBackend['owner_email']) {
    snap.ownerEmail = snapshotBackend['owner_email']
  }

  return snap
}

export interface SnapshotPayload {
  id?: number
  description?: string
  name?: string
  shared_with?: string
}
